import { Trans } from "@lingui/react/macro";

import { hasApiErrorCode, useApiErrorMessage } from "@/shared/api";

type StartAnalysisErrorProps = {
  error: unknown;
};

// Разбор не запустился. Текст ошибки — по коду из shared/api; для лимита бесплатных
// разборов он уже содержит время, когда появится следующий разбор.
export const StartAnalysisError = ({ error }: StartAnalysisErrorProps) => {
  const message = useApiErrorMessage(error);
  if (message === null) {
    return null;
  }
  const isLimit = hasApiErrorCode(error, "analysis_limit_reached");
  return (
    <div
      role="alert"
      data-error={isLimit ? "analysis_limit_reached" : undefined}
      className="flex flex-col gap-1 rounded-lg border border-warn/40 bg-warn/10 px-4 py-3 text-sm"
    >
      <p className="font-semibold text-warn">
        {isLimit ? (
          <Trans>Free analysis limit reached</Trans>
        ) : (
          <Trans>Analysis did not start</Trans>
        )}
      </p>
      <p className="text-foreground-soft">{message}</p>
    </div>
  );
};
